module.exports = __webpack_public_path__ + "img/still (34).bed9dc40.jpg";